import { useState } from "react";
import { Create, SimpleForm } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import SaveForm from "./SaveForm";

const CreateElectiveCourse = () => {
  const [documentId, setDocumentId] = useState(null);

  // The FileInput's own field keeps the raw picked-file preview (see DocumentFileInput) so it
  // stays visible after upload; the actual uploaded id is tracked separately and swapped in here.
  const transform = data => ({ ...data, documentId: documentId ?? data.documentId });

  return (
    <Create
      title="Създаване на свободноизбираем курс"
      transform={transform}
      actions={<BackButtonToolbar />}
    >
      <SimpleForm>
        <SaveForm onDocumentUpload={setDocumentId} />
      </SimpleForm>
    </Create>
  );
};

export default CreateElectiveCourse;
